var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_136)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.8333,
    cy: 9.16658,
    r: 5.83333,
    fill: "#3AFCC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.62 2.20173L10 0.00756836L3.37999 2.20173C2.88122 2.36708 2.44723 2.68538 2.13966 3.11142C1.83209 3.53747 1.66659 4.0496 1.66666 4.57506V10C1.66666 16.27 9.33333 19.7325 9.66166 19.8767L9.95666 20.0075L10.2633 19.9059C10.5933 19.7959 18.3333 17.1475 18.3333 10V4.57506C18.3334 4.0496 18.1679 3.53747 17.8603 3.11142C17.5528 2.68538 17.1188 2.36708 16.62 2.20173ZM10.37 11.6575C10.2243 11.8042 10.051 11.9205 9.85997 11.9996C9.669 12.0787 9.46421 12.1191 9.25749 12.1184H9.22999C9.01907 12.1151 8.81099 12.0692 8.61834 11.9832C8.42569 11.8973 8.25247 11.7732 8.10916 11.6184L6.18749 9.61838L7.38999 8.46672L9.25999 10.4167L13.5775 6.09922L14.7558 7.27755L10.37 11.6575Z",
    fill: "#7759F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.f5809a657d37d55e1a74f7bf64272029.svg";
export { ForwardRef as ReactComponent };